export interface ContactDetail {
	website: string;
	email: string;
	phone: string;
	fax: string;
}
